import { getLanguage } from '../../components/languageSelect/helpers/functions';
import { encrypted } from '../utility';

interface AuthUser {
  token: string;
}

const getDecryptedToken = (): AuthUser | null => {
  const authUser = localStorage.getItem('authToken');
  if (!authUser) return null;

  try {
    const decrypted = encrypted.decrypt(authUser);
    
    // Try to parse as JSON first
    try {
      const parsed = JSON.parse(decrypted);
      // If parsing succeeds, check if it has the expected structure
      if (parsed && typeof parsed === 'object' && 'token' in parsed) {
        return parsed as AuthUser;
      }
    } catch (parseError) {
      // If JSON parsing fails, check if it's a plain token string
      // This handles cases where the token might be stored as a plain string
      if (typeof decrypted === 'string' && decrypted.trim().length > 0) {
        // Check if it looks like a token (not starting with '{' or '[')
        if (!decrypted.trim().startsWith('{') && !decrypted.trim().startsWith('[')) {
          // Treat it as a plain token string and wrap it in the expected format
          return { token: decrypted.trim() };
        }
      }
      throw parseError; // Re-throw if it's not a plain token string
    }
    
    return null;
  } catch (err) {
    console.error('Failed to decrypt or parse auth token:', err);
    return null;
  }
};

export const createHeaders = () => {
  const tokenData = getDecryptedToken();

  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': getLanguage(),
    // webVersion: environment.versions.app,
  };

  return tokenData
    ? {
      ...headers,
      Authorization: 'Bearer ' + tokenData.token,
      // authServiceValidated: 'true',
    }
    : headers;
};


export const createBasicHeaders = () => {
  const tokenData = getDecryptedToken();

  const headers = {
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': getLanguage(),
  };

  return tokenData
    ? {
      ...headers,
      Authorization: 'Bearer ' + tokenData.token,
    }
    : headers;
};

export const createTokenHeader = () => {
  const tokenData = getDecryptedToken();

  const headers = {
    'content-type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': getLanguage(),
    // webVersion: environment.versions.app,
  };

  return tokenData
    ? {
      ...headers,
      Authorization: 'Bearer ' + tokenData.token,
      // authServiceValidated: 'true',
    }
    : headers;
};
